import React from 'react';
import { useThemeContext, WizardContext } from '../../../../context';
import { SelectGrid } from '../../SelectGrid';
import { WizardButton } from '../../../Shared/Wizard';
import { StyledLabel, WizardActions } from '../../../Shared/Styled';
import { SelectItem } from '../../../../types';
import { SearchBox } from '../../Search';

export interface SavedViewSelectionProps {
  items: SelectItem[];
  selected?: string;
  tabConfigured: boolean;
  onSearch: (input: string) => void;
  onClear: () => void;
  onChange: (input: string) => void;
}

export function SavedViewSelection({
  items,
  selected,
  tabConfigured,
  onSearch,
  onClear,
  onChange,
}: SavedViewSelectionProps) {
  const theme = useThemeContext();
  return (
    <WizardContext.Consumer>
      {({ goto }) => (
        <div
          id='SavedViewSelection'
          style={{
            display: 'inline-flex',
            width: '100%',
            flexDirection: 'column',
          }}
        >
          <StyledLabel style={{ marginTop: '9px' }} themeStr={theme}>
            <span>Select Default View</span>
          </StyledLabel>
          <SearchBox
            placeholder={'Enter filter criteria'}
            onSearch={onSearch}
            onClear={onClear}
            onChange={onChange}
            inputValue={undefined}
            isFilterBox={true}
            theme={theme}
          />
          <SelectGrid
            items={items}
            selected={selected}
            selectedProperty={'value'}
          ></SelectGrid>
          <WizardActions>
            <WizardButton
              direction='back'
              label={'Named Version'}
              onClick={() => goto('choose-named-version')}
              theme={theme}
            />
            {!tabConfigured && (
              <WizardButton
                direction='forward'
                label='Tab Name'
                disabled={items.length === 0 || !selected}
                onClick={() => goto('enter-tab-name')}
                theme={theme}
              />
            )}
          </WizardActions>
        </div>
      )}
    </WizardContext.Consumer>
  );
}
